import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import VueLazyload from 'vue-lazyload'

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.use(VueLazyload, {
  observer: true
})
